var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9598 11.96V1.60004H1.59985L11.9598 11.96Z",
    fill: "url(#paint0_linear_3_2495)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3201 11.9602V1.60025H11.9601L22.3201 11.9602Z",
    fill: "url(#paint1_linear_3_2495)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9598 22.3201V11.9601H1.59985L11.9598 22.3201Z",
    fill: "url(#paint2_linear_3_2495)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3201 22.3201V11.9601H11.9601L22.3201 22.3201Z",
    fill: "url(#paint3_linear_3_2495)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_2495",
    x1: 11.9598,
    y1: 1.60004,
    x2: 6.84453,
    y2: 6.60549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119479,
    stopColor: "#2F70FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469021,
    stopColor: "#089DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768361,
    stopColor: "#09D191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#6DED02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_2495",
    x1: 22.3201,
    y1: 1.60025,
    x2: 17.2048,
    y2: 6.60572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119479,
    stopColor: "#2F70FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469021,
    stopColor: "#089DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768361,
    stopColor: "#09D191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#6DED02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_2495",
    x1: 11.9598,
    y1: 11.9601,
    x2: 6.84453,
    y2: 16.9655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119479,
    stopColor: "#2F70FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469021,
    stopColor: "#089DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768361,
    stopColor: "#09D191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#6DED02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_2495",
    x1: 22.3201,
    y1: 11.9601,
    x2: 17.2048,
    y2: 16.9655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119479,
    stopColor: "#2F70FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469021,
    stopColor: "#089DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.768361,
    stopColor: "#09D191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#6DED02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowIcon);
export default __webpack_public_path__ + "static/media/GrowIcon.e496d60810ac693e023f88efb723c2fd.svg";
export { ForwardRef as ReactComponent };